import { TranslateParser, TranslateService } from '@ngx-translate/core';

/** Matches ngx-translate's own `templateMatcher`, so the scan sees exactly what it left behind. */
const PLACEHOLDER = /{{\s?([^{}\s]*)\s?}}/;

/**
 * Interpolates `key` and rejects the result if any placeholder went unbound.
 *
 * ngx-translate leaves the literal `{{name}}` in place for a missing param, so a
 * leftover scan is an exact detector. Returning `null` lets the caller fall to the
 * next rung of the message ladder instead of showing a half-rendered sentence.
 */
export function interpolateStrict(
  translate: TranslateService,
  key: string,
  params: Record<string, unknown>
): string | null {
  const interpolated = translate.instant(key, params);
  if (typeof interpolated !== 'string' || interpolated === key) {
    return null;
  }
  return PLACEHOLDER.test(interpolated) ? null : interpolated;
}

/**
 * [`interpolateStrict`](interpolateStrict) for a template GFE holds as a value rather than
 * as a translation key — DataLayer's `x-i18n-message`, which arrives from the error catalog
 * already picked for the active language.
 *
 * Goes through the same `TranslateParser` the translation rung uses, so a DataLayer template
 * and a GFE one bind their placeholders identically; anything else would make the rung a
 * message reaches change how it renders.
 */
export function interpolateStrictTemplate(
  parser: TranslateParser,
  template: string,
  params: Record<string, unknown>
): string | null {
  const interpolated = parser.interpolate(template, params);
  if (typeof interpolated !== 'string' || interpolated === '') {
    return null;
  }
  return PLACEHOLDER.test(interpolated) ? null : interpolated;
}
